<!-- 短信发送提模版 -->
<template>
  <div ref="smsDOM" class="sms">
    <a-modal
      :centered="true"
      width="1100px"
      v-model:visible="visible"
      :title="canSend ? '选择短信内容' : '提示'"
      @ok="onSubmit"
    >
      <!-- 第一级 -->
      <div class="outline-1">
        <a-radio-group
          @change="e => changeOutLine1(e.target.value)"
          class="radio"
          v-model:value="outline1.value"
        >
          <a-radio-button v-for="item in outline1.title" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </div>
      <!-- 第二级 -->
      <div v-if="outline2.component === 'select'" class="outline-2">
        <a-select
          @change="e => changeOutLine2(3, e)"
          v-for="outline in outline2.title"
          :key="outline.id"
          class="select"
          v-model:value="outline2.value"
          :options="outline.value"
        ></a-select>
      </div>
      <a-tabs
        class="outline-2"
        v-else
        @change="e => changeOutLine2(3, e)"
        v-model:activeKey="outline2.value"
      >
        <a-tab-pane v-for="tab in outline2.title" :key="tab.id" :tab="tab.name"></a-tab-pane>
      </a-tabs>
      <!-- 第三级 -->
      <div class="outline-3">
        <a-radio-group v-model:value="outline3.value">
          <a-radio
            class="outline3-radio"
            v-for="item in outline3.title"
            :key="item.templateId"
            :value="item.templateId"
          >
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { message, Modal } from 'ant-design-vue'
import { ref, defineExpose } from 'vue'
import { useSMS } from './hooks'
import { sendSms } from '@/api/workPlace/SMS'
const { smsDOM, outline1, outline2, outline3, canSend, sendBefore, smsTemplate } = useSMS()
const visible = ref(false) // 整体的弹窗隐藏显示
const role = ref(null)
const patientInfo = ref({
  id: '',
  name: ''
})
const doctorInfo = ref({
  id: '',
  name: ''
})
const workOrderId = ref(null)
// 当前发送人
const sendUser = ref({ id: '', name: '' })
// 打开入口
async function open(roleType, pInfo = {}, dInfo = {}, wid = null) {
  console.log('发短信')
  role.value = roleType
  patientInfo.value = pInfo
  doctorInfo.value = dInfo
  workOrderId.value = wid
  sendUser.value = roleType === 1 ? pInfo : dInfo
  const res = await sendBefore(roleType, sendUser.value.id)
  // 0表示操作成功，否则表示操作失败
  visible.value = res.code === 0
  if (visible.value) {
    await getOutLineTitle(1, 0)
    await getOutLineTitle(2, outline1.value)
    await getOutLineTitle(3, outline2.value)
  } else {
    Modal.warning({
      title: '提醒',
      content: res.message
    })
  }
}
// 获取 title 渲染
async function getOutLineTitle(level, parentId) {
  let isSelect = true
  // 第三层通用都不会有
  if (level === 3 && outline1.value === 1) {
    isSelect = false
  }
  const lineTemp = await smsTemplate(
    role.value,
    parentId,
    doctorInfo.value.id,
    isSelect ? outline2.value : null
  )
  // 第二类目 可能是拓展项
  let content = []
  switch (level) {
    case 1:
      outline1.title = lineTemp
      outline1.value = lineTemp.length ? lineTemp[0].id : ''
      outline1.component = lineTemp[0].componentType
      break
    case 2:
      outline2.title = lineTemp
      outline2.component = lineTemp[0].componentType
      // 判断是不是拓展项
      if (outline2.component === 'select') {
        // 默认取第一项内容
        content = lineTemp[0].value
        outline2.value = content[0].value
      } else {
        outline2.value = lineTemp.length ? lineTemp[0].id : ''
      }
      break
    case 3:
      outline3.title = lineTemp
      outline3.value = lineTemp.length ? lineTemp[0].templateId : ''
      break
  }
  return lineTemp
}
// 点击第一类
async function changeOutLine1() {
  await getOutLineTitle(2, outline1.value)
  await getOutLineTitle(3, outline2.value)
}
// 点击第二类
async function changeOutLine2() {
  await getOutLineTitle(3, outline2.value)
}
// 提交
function onSubmit() {
  const title1 = outline1.title.find(f => f.id === outline1.value).name
  // 查询第二层 医院 或者提醒类
  let title2 = ''
  for (let index = 0; index < outline2.title.length; index++) {
    const element = outline2.title[index]
    const hasSelect = element === 'select'
    // 有下拉数据 则从里面进行过滤
    if (hasSelect) {
      const _title = element.value.find(e => e.value === outline2.value)
      if (_title) title2 = _title.label
    } else {
      if (outline2.value === element.id) {
        title2 = element.name
        break
      }
    }
  }
  const params = {
    sendType: role.value,
    sendTypeSnapshot: title1 + '-' + title2,
    workOrderId: workOrderId.value,
    templateId: outline3.value,
    receivePersonId: sendUser.value.id,
    receivePersonRole: role.value,
    doctorUcId: doctorInfo.value.id,
    patientUcId: patientInfo.value.id,
    hospitalId: outline2.value,
    templateParas: {
      doctorUcId: doctorInfo.value.id,
      // 只有提醒类不需要 hospital id
      hospitalId: outline1.value === 1 ? null : outline2.value
    }
  }
  sendSms(params).then(() => {
    const r = role.value === 1 ? '患者' : '医生'
    const text = `${r}-${sendUser.value.name}短信发送成功`
    message.success(text)
    visible.value = false
  })
}
defineExpose({
  open
})
</script>
<style scoped lang="scss">
.sms {
  .button {
    margin-top: 12px;
  }
}
.outline-1 {
  text-align: center;
  .radio {
    display: inline-block;
    .ant-radio-button-wrapper {
      &:first-child {
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
}
.outline-2 {
  margin-top: 20px;
  .select {
    width: 220px;
  }
  ::v-deep(.ant-tabs-content) {
    display: none;
  }
}
.outline-3 {
  .outline3-radio {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px 0 0 0;
    padding: 12px 16px;
    background: #fafafa;
    white-space: normal;
  }
}
</style>
